/**
 * Payment Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserPaymentAccountRoleSimpleDto } from './userPaymentAccountRoleSimpleDto';
import { AddressDto } from './addressDto';


export interface PaymentAccountSimpleDtoWithRoles { 
    id?: number;
    insertTs: string;
    fakturaCustomerRefNo: number;
    accountNumber: number;
    invoiceAddress?: AddressDto;
    accountName: string;
    currency: PaymentAccountSimpleDtoWithRoles.CurrencyEnum;
    preferredPaymentMethod?: PaymentAccountSimpleDtoWithRoles.PreferredPaymentMethodEnum;
    internalComment?: string;
    active: boolean;
    confirmed: boolean;
    userPaymentAccountRoles?: Array<UserPaymentAccountRoleSimpleDto>;
}
export namespace PaymentAccountSimpleDtoWithRoles {
    export const CurrencyEnum = {
        Usd: 'USD',
        Eur: 'EUR',
        Cad: 'CAD'
    } as const;
    export type CurrencyEnum = typeof CurrencyEnum[keyof typeof CurrencyEnum];
    export const PreferredPaymentMethodEnum = {
        CreditCard: 'CREDIT_CARD',
        BankTransfer: 'BANK_TRANSFER'
    } as const;
    export type PreferredPaymentMethodEnum = typeof PreferredPaymentMethodEnum[keyof typeof PreferredPaymentMethodEnum];
}


